import './_account-drawer.scss';
import component from './account-drawer';

export default component;
